import { IResponsiveComponentLayoutConfigs } from '@faire/web-api--source/indigofair/data/IResponsiveComponentLayoutConfigs';
import { IResponsiveFloats } from '@faire/web-api--source/indigofair/data/IResponsiveFloats';
import { IResponsiveSpacing } from '@faire/web-api--source/indigofair/data/IResponsiveSpacing';

export namespace IFlowLayout {
  /**
   * Return an instance of IFlowLayout with the provided fields. Any field not
   * listed will be populated with an empty value (an empty array,
   * or undefined, whichever is valid for the type of the value.)
   */
  export const build = (partial?: Partial<IFlowLayout>): IFlowLayout =>
    ({
      ...(partial ?? {}),
    }) as IFlowLayout;
}

/**
 * This lays out components based off a list of responsive component widths.
 * All list fields must be read in order from index 0 to determine the layout.
 * Flowing from left to right, overflowing to the next row after the screen width is reached.
 */
export interface IFlowLayout {
  /**
   * the list of component widths represented as the percentage of the screen
   * TODO (Shiqing): Deprecate after ResponsiveComponentLayoutConfig is supported
   */
  component_widths: IResponsiveFloats | undefined;
  /**
   * the spacing between rows in the layout
   */
  row_spacing: IResponsiveSpacing | undefined;
  /**
   * the spacing between columns in the layout
   */
  column_spacing: IResponsiveSpacing | undefined;
  /**
   * The list of responsive component layout configurations.
   */
  responsive_component_layout_configs:
    | IResponsiveComponentLayoutConfigs
    | undefined;
}
